'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    INITIAL_STATE_INGRESO_AJUSTES,
    GET_DATA_INGRESO_AJUSTES,
    RECEIVE_DATA_INGRESO_AJUSTES,
    CHANGE_DATA_INGRESO_AJUSTES,
    EXPANDIR_ROW_INGRESO_AJUSTES,
    SUCCESS_INGRESO_AJUSTES,
    LIMPIAR_INGRESO_AJUSTES,
    ELIMINAR_INGRESO_AJUSTES,
    EDITAR_INGRESO_AJUSTES,
    CONFIRMAR_INGRESO_AJUSTES,
    DENEGAR_INGRESO_AJUSTES,
    CHANGE_IMPORTE_SIN_IVA,
    SELECCIONAR_RADIO,
    LOADING_INGRESO_AJUSTE,
    ACTUALIZAR_DATA_MOTIVOAJUSTE,
    SET_USER_FUNCTIONS_AJUSTES_CARGOS,
    UPDATE_MOTIVO_AJUSTE_COMBO,
    UPDATE_MONEDA_COMBO,
    UPDATE_DATA_MONEDA,
    UPDATE_AJUSTE_CARGO_ESTADO,
    REINICIAR_VALORES,
    ACTUALIZA_REFERENCIA,
    OPEN_MODAL,
    OPEN_MODAL_INFO,
    ERRORES_FORMULARIO
} from '../../Screens/DatosCuenta/actions/IngresoAjustesActions'

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        cuenta: undefined,
        ajustes: [],
        siNoConfirmacion: [],
        tipoMoneda: [],
        fechaValor: new Date(),
        monedaId: 0,
        cuentaTarjetaId: undefined,
        ajusteMotivo: [],
        tarjetaVigencia: [],
        rowSeleccionada: undefined,
        sucursalId: 0,
        ajusteEstadoId: 0,
        ajusteOrigenId: 0,
        tarjetaCreditoId: 0,
        debitoCredito: undefined,
        impactaPeriodo: undefined,
        permiteIva: 0,
        tasaIva: 1,
        motivoAjusteId: 0,
        importeConIva: 0,
        importeSinIva: "",
        isLoading: false,
        ajusteCargoRdButton: 0,
        motivoAjusteData: [],
        datosAjuste: [],
        parametroGeneral: {},
        motivoAjusteDataFiltrado: undefined,
        referencia: "",
        permisos: undefined,
        accion: "guardar",
        mostrarModalAjustes: false,
        executionContext: undefined,
        errorAjusteCargoSelect: false,
        errorDebitoCredito: false,
        errorImporteSinIva: false,
        mostrarModalInfo: false,
        ajusteEstados: undefined,
        cargoEstados: undefined,
        msjModalInfo: ""
    }
};

function ingresoAjustes(state = initialState, action) {
    LogHelper.In(ingresoAjustes.name, state, action);

    switch (action.type) {

        case OPEN_MODAL: {
            return {
                ...state,
                data: {
                    ...state.data,
                    mostrarModalAjustes: action.valor
                }
            };
        }

        case OPEN_MODAL_INFO: {
            return {
                ...state,
                data: {
                    ...state.data,
                    mostrarModalInfo: action.valor,
                    msjModalInfo: action.mensaje
                }
            };
        }
        

        case ACTUALIZA_REFERENCIA: {
            return {
                ...state,
                data: {
                    ...state.data,
                    referencia: action.referencia
                }
            };
        }

        case ERRORES_FORMULARIO: {
            return {
                ...state,
                data: {
                    ...state.data,
                    errorDebitoCredito: action.errorDebitoCredito,
                    errorAjusteCargoSelect: action.errorAjusteCargoSelect,
                    errorImporteSinIva: action.errorImporteSinIva
                }
            };
        }

        case REINICIAR_VALORES: {
            return {
                ...state,
                data: {
                    ...state.data,
                    tipoMoneda: [],
                    monedaId: 0,
                    debitoCredito: undefined,
                    impactaPeriodo: undefined,
                    permiteIva: 0,
                    motivoAjusteId: 0,
                    importeConIva: 0,
                    importeSinIva: "",
                    ajusteCargoRdButton: 0,
                    motivoAjusteDataFiltrado: undefined,
                    referencia: "",
                    motivoAjusteData: state.data.datosAjuste,
                    mostrarModalAjustes: false,
                    errorAjusteCargoSelect: false,
                    errorDebitoCredito: false,
                    ajusteEdicion: undefined,
                    motivoAjusteEdicion: undefined,
                    accion: "guardar",
                    datosEdicion: undefined,
                    mostrarModalInfo: false,
                    ajusteEstados: undefined,
                    cargoEstados: undefined
                }
            };
        }

        case SELECCIONAR_RADIO: {
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.campo]: action.valor,
                    errorDebitoCredito: false
                }
            };
        }

        case UPDATE_DATA_MONEDA: {
            return {
                ...state,
                data: {
                    ...state.data,
                    tipoMoneda: action.data,
                }
            };
        }

        case UPDATE_AJUSTE_CARGO_ESTADO: {
            return {
                ...state,
                data: {
                    ...state.data,
                    ajusteEstados: action.ajusteEstados,
                    cargoEstados: action.cargoEstados
                }
            };
        }

        

        case ACTUALIZAR_DATA_MOTIVOAJUSTE: {
            return {
                ...state,
                data: {
                    ...state.data,
                    motivoAjusteData: action.data
                }
            };
        }

        case SET_USER_FUNCTIONS_AJUSTES_CARGOS:
            return {
                ...state,
                data: {
                    ...state.data,
                    permisos: action.functions,
                    parametroGeneral: action.parametroGeneral,
                    executionContext: action.executionContext
                }
            };

        case INITIAL_STATE_INGRESO_AJUSTES:
            return initialState;

        case GET_DATA_INGRESO_AJUSTES:
            return initialState

        case RECEIVE_DATA_INGRESO_AJUSTES: {
            if (action.motivoId == undefined) {
                return {
                    ...initialState,
                    data: {
                        ...initialState.data,
                        ajustes: action.data.ajustes,
                        siNoConfirmacion: action.data.siNoConfirmacion,
                        tipoMoneda: action.data.tipoMoneda,
                        fechaCobranza: action.data.fechaCobranza,
                        ajusteMotivo: action.data.ajusteMotivo,
                        cuentaTarjetaId: action.data.cuentaTarjetaId,
                        sucursalId: action.data.sucursalId,
                        ajusteEstadoId: action.data.cobranzaEstadoId,
                        ajusteOrigenId: action.data.cobranzaOrigenId,
                        tarjetaCreditoId: action.data.tarjetaCreditoId,
                        tarjetaVigencia: action.data.tarjetaVigencia,
                        isLoading: false,
                        motivoAjusteData: action.data.motivoAjusteData,
                        permisos: action.data.permisos,
                        parametroGeneral: action.data.parametroGeneral,
                        executionContext: action.data.executionContext,
                        datosAjuste: action.data.motivoAjusteData, // Se guarda un back para cuando se limpie la variable no tener que pegarle nuevamente a e1
                        ajusteEstados: action.data.ajusteEstados,
                        cargoEstados: action.data.cargoEstados
                    }
                }

            }

            return {
                ...state,
                data: {
                    ...state.data,
                    ajustes: action.data.ajustes,
                    siNoConfirmacion: action.data.siNoConfirmacion,
                    tipoMoneda: action.data.tipoMoneda,
                    fechaCobranza: action.data.fechaCobranza,
                    ajusteMotivo: action.data.ajusteMotivo,
                    cuentaTarjetaId: action.data.cuentaTarjetaId,
                    sucursalId: action.data.sucursalId,
                    ajusteEstadoId: action.data.cobranzaEstadoId,
                    ajusteOrigenId: action.data.cobranzaOrigenId,
                    tarjetaCreditoId: action.data.tarjetaCreditoId,
                    tarjetaVigencia: action.data.tarjetaVigencia,
                    isLoading: false,
                    permisos: action.data.permisos,
                    ajusteEstados: action.data.ajusteEstados,
                    cargoEstados: action.data.cargoEstados
                }
            };
        }
        case CHANGE_DATA_INGRESO_AJUSTES:

            return {
                ...state,
                data: {
                    ...state.data,
                    debitoCredito: action.data.debitoCredito,
                    tipoMoneda: action.data.tipoMoneda,
                    monedaId: (action.data.tipoMoneda[0].Id || 0),
                    impactaPeriodo: action.data.impactaPeriodo,
                    permiteIva: action.data.permiteIva,
                    tasaIva: action.data.tasaIva,
                    cuentaTarjetaId: action.data.cuentaTarjetaId

                }
            };

        case UPDATE_MOTIVO_AJUSTE_COMBO:
            let debitoCredito = action.motivoAjusteDataFiltrado && action.motivoAjusteDataFiltrado.DebitoCredito ? action.motivoAjusteDataFiltrado.DebitoCredito : undefined;
            return {
                ...state,
                data: {
                    ...state.data,
                    motivoAjusteId: action.id,
                    debitoCredito: debitoCredito,
                    motivoAjusteDataFiltrado: action.motivoAjusteDataFiltrado,
                    importeConIva:0,
                    ajusteEdicion: undefined,
                    errorAjusteCargoSelect: false,
                    errorDebitoCredito: false
                }
            }

        case UPDATE_MONEDA_COMBO:
            return {
                ...state,
                data: {
                    ...state.data,
                    monedaId: action.id
                }
            }

        case CHANGE_IMPORTE_SIN_IVA:
            return {
                ...state,
                data: {
                    ...state.data,
                    importeConIva: action.numero,
                    importeSinIva: action.numero,
                    errorImporteSinIva: action.esError
                }
            }

        case EXPANDIR_ROW_INGRESO_AJUSTES:
            let id = undefined;
            if (state.data.rowSeleccionada != action.id) {
                if (state.data.rowSeleccionada == action.id) {
                    id = undefined
                }
                else {
                    id = action.id
                }
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    rowSeleccionada: id
                }
            };

        case SUCCESS_INGRESO_AJUSTES:
            return {
                ...state,
                isLoading: false
            };

        case LOADING_INGRESO_AJUSTE: {
            return {
                ...state,
                data: {
                    ...state.data,
                    isLoading: action.valor
                }
            };
        }

        case LIMPIAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                    accion: "guardar"
                }
            };

        case ELIMINAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case EDITAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                    accion: 'edicion',
                    ajusteEdicion: action.ajuste,
                    motivoAjusteEdicion: action.resultado.motivoAjusteData,
                    motivoAjusteDataFiltrado: action.ajuste,
                    referencia: action.ajuste.Referencia,
                    importeSinIva: action.ajuste.ImporteSinIVA,
                    monedaId: action.ajuste.MonedaId,
                    datosEdicion: action.ajuste
                }
            }

        case CONFIRMAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case DENEGAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }
            return {
                ...state,
                data: {
                    ...state.data,
                    rowSeleccionada: id
                }
            };
        default:
            return state;
    }
}

export default ingresoAjustes;